import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React, { Component } from "react";
import ReactDOM, { render } from "react-dom";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import MainPixelogList from "./components/Main/MainPixelogList";
import ViewPixelogList from "./components/View/ViewPixelogList";
import MainPixelogSearchList from "./components/Main/MainPixelogSearchList";

render(
  <Router>
    <Switch>
      <Route path="/search/:query" component={MainPixelogSearchList} />
      <Route path="/pixelog/view/:id" component={ViewPixelogList} />

      <Route path="/" exact component={MainPixelogList} />
      {/*<Route path="/new" exact component={MainPixelogList} />*/}
      <Route path="/diary" exact component={MainPixelogList} />
      <Route path="/challenges" exact component={MainPixelogList} />
      <Route path="/likes" exact component={MainPixelogList} />
      <Route path="/tags" exact component={MainPixelogList} />

      {/* <Route path="/" exact component={test} />   */}
    </Switch>
  </Router>,
  document.getElementById("app"),
);
